import { render, staticRenderFns } from "./ElegantRoom.vue?vue&type=template&id=57600ab0&scoped=true&"
import script from "./ElegantRoom.vue?vue&type=script&lang=js&"
export * from "./ElegantRoom.vue?vue&type=script&lang=js&"
import style0 from "./ElegantRoom.vue?vue&type=style&index=0&id=57600ab0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57600ab0",
  null
  
)

export default component.exports